import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Table } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchBox from "../../../components/SearchBox";
import AddOverTime from "../../../components/modelpopup/AddOverTime";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { getAllExpenses } from "../../../services/reimbursementService";
import { formatDateInTimezone } from "../../../utils/formatDateInTimezone";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import { companyID } from "../../../auth";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../../api/axios";
import AttachmentModal from "../../../components/modelpopup/AttachmentModal";
import { decrypt } from "../../../utils/crypto";

const Reimbursement = () => {
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const [expenses, setExpenses] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [appliedReimbursement, setAppliedReimbursement] = useState(0);
  const [noOfReimbursementForApproval, setNoOfReimbursementForApproval] =
    useState(0);
  const [showNames, setShowNames] = useState(false);
  const [activeStat, setActiveStat] = useState("Applied Reimbursement");
  const [acknowledgeAttachment, setAcknowledgeAttachment] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [reimbursementId, setReimbursementId] = useState(null);
  const [acknowledge, setAcknowledge] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const loginEmployeeId = localStorage.getItem("employeeID");

  const navigate = useNavigate();

  const fetchExpenses = async () => {
    console.log(" handlerApprovalStatus fetchExpenses calling");
    try {
      setLoading(true);
      const data = await getAllExpenses(employee_id);
      console.log("data.filter((item) => item.status !== 0) : ", data);
      console.log(" handlerApprovalStatus fetchExpenses data : ", data);
      setExpenses(data.filter((item) => item.status !== 0));
      setAppliedReimbursement(data.filter((item) => item.status !== 0).length);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  useEffect(() => {
    handlerApprovalStatus();
  }, []);

  const statsData = [
    {
      title: "Applied Reimbursement",
      value: appliedReimbursement,
    },
    {
      title: "Pending for Approval",
      value: noOfReimbursementForApproval,
    },
    // {
    //   title: "Rejected",
    //   value: 5,
    // },
  ];

  const deleteReimbursement = (reimbursementId, e) => {
    e.preventDefault();
    console.log("deleteReimbursement : ", reimbursementId);
    api
      .put(`api/reimbursement-delete/${reimbursementId}`)
      .then(() => fetchExpenses());
  };

  const reimbursementStatus = [
    { value: 2, label: "Approved" },
    { value: 3, label: "Rejected" },
  ];
  const company_id = companyID();

  const reimbursementStatusIdHandler = async (status_id, reimbursement_id) => {
    try {
      const response = await api.post(
        `api/reimbursementsForApprova/${reimbursement_id}`,
        {
          approver_id: employee_id,
          status_id: status_id,
          company_id: company_id,
        }
      );
      if (response.status == 200) {
        setCurrentStatus(status_id);
        handlerApprovalStatus("Pending for Approval");
      }
      console.log("reimbursementStatusIdHandler : response : ", response);
    } catch (error) {
      console.error("Error updating reimbursement:", error);
    }
  };

  const columns = [
    // {
    //   title: "#",
    //   // dataIndex: "id",
    //   render: (text, record, index) => index + 1,
    //   sorter: (a, b) => a.id.length - b.id.length,
    // },
    {
      title: "Title",
      dataIndex: "expense_type",
      render: (text, record) => <span className="table-avatar">{text}</span>,
    },
    {
      title: "Claimed on",
      dataIndex: "created_at",
      render: (text, record) => formatDateInTimezone(record?.created_at),
      sorter: (a, b) => a.created_at - b.created_at,
    },
    {
      title: "Expense date",
      dataIndex: "expense_date",
      render: (text, record) => formatDateInTimezone(record.expense_date),
      sorter: (a, b) =>
        new Date(a.expense_date).getTime() - new Date(b.expense_date).getTime(),
    },
    {
      title: "Amount claimed",
      dataIndex: "expense_amount",
    },
    ...(showNames
      ? [
          {
            title: "Status",
            dataIndex: "updated_status",
            sorter: (a, b) => a.updated_status - b.updated_status,
            render: (text, record) => (
              <span
                style={{
                  color:
                    record.updated_status === 1
                      ? "rgb(255 223 0)"
                      : record.updated_status === 2
                      ? "green"
                      : "red",
                }}
              >
                {record.updated_status === 1
                  ? "Pending"
                  : record.updated_status === 2
                  ? "Approved"
                  : "Rejected"}
              </span>
            ),
          },
        ]
      : [
          {
            title: "Status",
            dataIndex: "expense_status",
            sorter: (a, b) => a.expense_status - b.expense_status,
            render: (text, record) => (
              <span
                style={{
                  color:
                    record.expense_status === 1
                      ? "rgb(255 223 0)"
                      : record.expense_status === 2
                      ? "green"
                      : "red",
                }}
              >
                {record.expense_status === 1
                  ? "Pending"
                  : record.expense_status === 2
                  ? "Approved"
                  : "Rejected"}
              </span>
            ),
          },
        ]),
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Action",
            render: (record) => (
              <div className="action-menu">
                {!showNames ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record?.updated_status == 1 ? "pointer" : "not-allowed",
                    }}
                  >
                    <button
                      disabled={record?.updated_status == 1 ? false : true}
                      className="list-group-item list-group-item-action"
                      onClick={(e) => {
                        // deleteReimbursement(record.id, e);
                        navigate("../create-expense");
                      }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip
                            id="tooltip-view"
                            style={{ fontSize: "12px", padding: "2px" }}
                          >
                            Edit
                          </Tooltip>
                        }
                      >
                        <i
                          className={`fa fa-pencil ${
                            record?.updated_status != 1
                              ? "text-muted"
                              : "text-info"
                          }`}
                        />
                      </OverlayTrigger>
                    </button>
                    <button
                      disabled={record?.updated_status == 1 ? false : true}
                      className="list-group-item list-group-item-action"
                      onClick={(e) => {
                        deleteReimbursement(record.id, e);
                      }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip
                            id="tooltip-view"
                            style={{ fontSize: "12px", padding: "2px" }}
                          >
                            Delete
                          </Tooltip>
                        }
                      >
                        <i
                          className={`fa fa-trash ${
                            record?.updated_status != 1
                              ? "text-muted"
                              : "text-danger"
                          }`}
                        />
                      </OverlayTrigger>
                    </button>
                  </div>
                ) : (
                  <div className="d-flex gap-4 mt-2">
                    <button
                      className="list-group-item list-group-item-action"
                      onClick={() => {
                        setModalShow(true);
                        setCurrentStatus(record?.updated_status);
                        setReimbursementId(record?.id);
                        setAcknowledgeAttachment(record?.attachment);
                      }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip
                            id="tooltip-view"
                            style={{ fontSize: "12px", padding: "2px" }}
                          >
                            View attachment
                          </Tooltip>
                        }
                      >
                        <i className="fa-regular fa-eye text-info" />
                      </OverlayTrigger>
                    </button>
                  </div>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  if (showNames) {
    columns.unshift({
      title: "Employee",
      dataIndex: "first_name",
      render: (text, record) => {
        const full_name = `${record?.first_name} ${record?.middle_name ?? ""} ${
          record?.last_name
        }`;
        return <span>{full_name}</span>;
      },
    });
  }

  const handlerApprovalStatus = async (approve) => {
    console.log(" handlerApprovalStatus call ");
    setExpenses([]);
    console.log(" handlerApprovalStatus expenses : ", expenses);
    try {
      const response = await api.get(
        `api/reimbursementsForApproval/${employee_id}`
      );
      const approvalData = response.data.result;

      const response2 = await api.get(
        `api/reimbursement-for-approval/${employee_id}`
      );

      const approvalData2 = response2.data.result;

      if (approve === "Pending for Approval") {
        let combinedData = [];

        if (approvalData.length > 0) {
          combinedData = [...combinedData, ...approvalData];
        }
        if (approvalData2.length > 0) {
          combinedData = [...combinedData, ...approvalData2];
        }

        if (combinedData.length > 0) {
          console.log(" handlerApprovalStatus combinedData : ", combinedData);
          setExpenses(combinedData);
          console.log("combinedData : ", combinedData);
        }
        setActiveStat("Pending for Approval");
        // console.log("Reimbursement data", approvalData);
        setShowNames(true);
      } else {
        console.log(
          " handlerApprovalStatus calling else fetchExpenses : ",
          expenses
        );
        setExpenses([]);
        setShowNames(false);
        fetchExpenses();
        let combinedData = [];

        if (approvalData.length > 0) {
          combinedData = [...combinedData, ...approvalData];
        }
        if (approvalData2.length > 0) {
          combinedData = [...combinedData, ...approvalData2];
        }
        setNoOfReimbursementForApproval(
          combinedData.filter(
            (reimbursement) => reimbursement.expense_status === 1
          ).length
        );
        setActiveStat("Applied Reimbursement");
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid position-relative">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={`${employeeName} Reimbursement`}
            title="Dashboard"
            subtitle="reimbursement"
            // modal="#add_overtime"
            name="Create Expenses"
            page="create-expense"
            action={loginEmployeeId === employee_id && "create"}
          />
          <AttachmentModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            attachmentUrl={acknowledgeAttachment}
            acknowledge={acknowledge}
            setAcknowledge={setAcknowledge}
            currentStatus={currentStatus}
            reimbursementId={reimbursementId}
            reimbursementStatusIdHandler={reimbursementStatusIdHandler}
            config={{ IMAGE_URL: config.IMAGE_URL }}
          />
          {/* /Page Header */}
          <div className="row d-flex ">
            {statsData.map((data, index) => (
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" key={index}>
                <div
                  className="stats-info "
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      data.title === activeStat ? "var(--company-theme)" : "",
                  }}
                  onClick={() => {
                    setExpenses([]);
                    handlerApprovalStatus(data.title);
                  }}
                >
                  <h6
                    style={{
                      color: data.title === activeStat ? "white" : "",
                    }}
                  >
                    {data.title}
                  </h6>
                  <h4
                    style={{
                      color: data.title === activeStat ? "white" : "",
                    }}
                  >
                    {data.value}
                  </h4>
                </div>
              </div>
            ))}
          </div>
          {/* /Overtime Statistics */}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  columns={columns}
                  dataSource={expenses}
                  rowKey={(record) => record.id}
                  scroll={{ x: true }}
                  tableLayout="auto"
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* <AddOverTime /> */}
      <DeleteModal Name="Delete Overtime" />
    </>
  );
};

export default Reimbursement;
